import { createContext } from "react";
const requisitionsContext = createContext();
export default requisitionsContext;
